var map = {
	"./BOOK  56649 - Máq. 16ton longo.pdf": 342,
	"./BOOK 1 - 56680 - Máq. 14ton.pdf": 343,
	"./BOOK 56670 - Barra de carga stacker 1.pdf": 344,
	"./BOOK 56682 - Barra de carga stacker 2.pdf": 345,
	"./BOOK 56698 - Máq. 16ton curto.pdf": 346
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 341;